/*
* @Description: 对外API维护
* @Author: fxg
* @Date: 2020-06-29 11:18:28
* @LastEditors: fxg
* @LastEditTime: 2020-06-29 13:34:36
*/
import request from '@/utils/request'
/*关键日志列表*/
export function query_page(data) {
  return request({
    url: '/logs/outer/logs/query_page',
    method: 'post',
    data
  })
}
/*关键日志列表*/
export function query_pageV2(data) {
  return request({
    url: '/logs/outer/logs/query_pageV2',
    method: 'post',
    data,
    timeout:180000,
  })
}

